export const FeedbackRestrictedPageList = [
  'auth',
  'kart'
]
